<template>
  <v-app>
    <Navigations :breadcrumbs="this.breadcrumb" />
    <v-main>
      <v-container>
        <v-row>
          <v-col cols="12">
            <v-row>
              <v-col cols="12">
                <div class="kyano-card-mobile-small">
                  <KyanoCard :data="data" />
                </div>
              </v-col>
              <v-col cols="12">
                <div v-for="profile in data.profiles" :key="profile.title">
                  <h2 v-if="profile.status === true" class="text-center my-0">
                    {{ profile.name }}
                  </h2>
                </div>
                <p class="text-center my-0">Businesscard</p>
              </v-col>
            </v-row>
          </v-col>

          <v-col
            offset-md="2"
            cols="12"
            md="8"
            class="kyano-responsive-col-width"
          >
            <v-card elevation="0" outlined class="kyano-responsive-card-width">
              <v-select
                :items="profileitems"
                label="Actief profiel"
                outlined
                persistent-hint
                hint="Dit profiel is zichtbaar op de Kyano Card bij een QR scan of NFC Tab."
              ></v-select>
            </v-card>

            <v-card elevation="0" outlined class="kyano-responsive-card-width">
              <v-row>
                <v-col cols="12" sm="4">
                  <span v-html="'Kaartnummer'" class="overline"> </span>
                  <p>{{ data.card_no }}</p>
                </v-col>
                <v-col cols="12" sm="4">
                  <span v-html="'Actief sinds'" class="overline"> </span>
                  <p>{{ data.active_since }}</p>
                </v-col>
                <v-col cols="12" sm="4">
                  <span v-html="'Aantal cardtabs'" class="overline"> </span>
                  <p>{{ data.count_cardtabs }}X</p>
                </v-col>
              </v-row>
            </v-card>

            <v-card elevation="0" outlined class="kyano-responsive-card-width">
              <h4 class="text-h6 mb-4">Gekoppelde profielen:</h4>
              <v-list>
                <v-list-item
                  v-for="profile in data.profiles"
                  :key="profile.title"
                  v-bind:class="{ activeprofile: profile.status }"
                >
                  <v-row>
                    <v-col cols="6" class="px-0 d-flex">
                      <v-list-item-avatar>
                        <v-img
                          :alt="`${profile.title} avatar`"
                          :src="profile.avatar"
                        ></v-img>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <strong v-text="profile.name"></strong>
                        <v-list-item-title
                          v-text="profile.functiontitle"
                        ></v-list-item-title>
                      </v-list-item-content>
                    </v-col>
                    <v-col cols="4" class="my-auto">
                      <v-list-item-content>
                        <v-list-item-title
                          v-text="profile.companyname"
                        ></v-list-item-title>
                      </v-list-item-content>
                    </v-col>
                    <v-col cols="2" class="text-right ml-auto my-auto">
                      <v-menu offset-y>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            color="primary"
                            icon
                            elevation="0"
                            v-bind="attrs"
                            v-on="on"
                          >
                            <v-icon>fal fa-ellipsis-v</v-icon>
                          </v-btn>
                        </template>
                        <v-list>
                          <v-list-item to="/profiles/create">
                            Profiel loskoppelen
                          </v-list-item>
                          <v-list-item @click="openMenu">
                            Profielen bewerken
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </v-col>
                  </v-row>
                </v-list-item>
              </v-list>
              <v-divider></v-divider>
              <DialogAddProfile :data="data" />
            </v-card>

            <v-card elevation="0" outlined class="kyano-responsive-card-width">
              <h4 class="text-h6 mb-4">Deze card is gedeeld met:</h4>

              <v-row class="px-3">
                <v-col cols="4" class="px-0 d-flex">
                  <v-list-item-content>
                    <strong v-text="'Naam'"></strong>
                  </v-list-item-content>
                </v-col>
                <v-col cols="4" class="my-auto">
                  <v-list-item-content>
                    <strong v-text="'E-mailadres'"></strong>
                  </v-list-item-content>
                </v-col>
                <v-col cols="4" class="my-auto">
                  <v-list-item-content>
                    <strong v-text="'Status'"></strong>
                  </v-list-item-content>
                </v-col>
       
              </v-row>
              <v-divider></v-divider>
              <v-list>
                <v-list-item v-for="item in data.cardShared" :key="item.name">
                  <v-row>
                    <v-col cols="4" class="px-0 d-flex">
                      <v-list-item-content>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">                         
                            <v-list-item-title  v-bind="attrs"
                              v-on="on"
                          v-text="item.name"
                        ></v-list-item-title>
                          </template>
                          <span>{{item.name}}</span>
                        </v-tooltip>

                      </v-list-item-content>
                    </v-col>
                    <v-col cols="4" class="my-auto">
                      <v-list-item-content>

                         <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">                         
                            <v-list-item-title  v-bind="attrs"
                              v-on="on"
                          v-text="item.email"
                        ></v-list-item-title>
                          </template>
                          <span>{{item.email}}</span>
                        </v-tooltip>

                        
                      </v-list-item-content>
                    </v-col>
                    <v-col cols="2" class="my-auto">
                      <v-list-item-content>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              v-bind="attrs"
                              v-on="on"
                              v-if="item.status === true"
                              color="secondary"
                              >fal fa-check</v-icon
                            >
                          </template>
                          <span>Geaccepteerd</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              v-bind="attrs"
                              v-on="on"
                              v-if="item.status === false"
                              color="light"
                              >fal fa-hourglass</v-icon
                            >
                          </template>
                          <span>Uitgenodigd</span>
                        </v-tooltip>
                      </v-list-item-content>
                    </v-col>
                    <v-col cols="2" class="text-right ml-auto my-auto">
                      <v-menu offset-y>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            color="primary"
                            icon
                            elevation="0"
                            v-bind="attrs"
                            v-on="on"
                          >
                            <v-icon>fal fa-ellipsis-v</v-icon>
                          </v-btn>
                        </template>
                        <v-list>
                          <v-list-item @click="deleteinvite">
                            Uitgenodigde verwijderen
                          </v-list-item>
                          <v-list-item @click="openMenu">
                            Deel instellingen
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </v-col>
                  </v-row>
                </v-list-item>
              </v-list>
              <v-divider></v-divider>
              <DialogShareCard :data="data" />
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>
<script>
import DialogAddProfile from "../../components/cards/DialogAddProfile.vue";
import DialogShareCard from "../../components/cards/DialogShareCard.vue";
import Navigations from "../../components/Navigations.vue";
import KyanoCard from "../../components/KyanoCard.vue";

export default {
  components: {
    Navigations,
    KyanoCard,
    DialogAddProfile,
    DialogShareCard,
  },

  data() {
    return {
      breadcrumb: [
        {
          text: "Cards",
          disabled: false,
          href: "/cards",
        },
        {
          text: "Card",
          disabled: true,
          href: `/cards/${this.$route.params.id}`,
        },
      ],
      data: {
        dialogaddprofile: false,
        dialogsharecard: false,
        companyname: "1234-5678-1234",
        card_no: "1234-5678-1234",
        count_cardtabs: "123",
        active_since: "01-01-2021",

        cardShared: [
          {
            name: "naam1",
            email: "naam@kyano.app",
            status: true,
          },
          {
            name: "naam2",
            email: "naam2@kyano.app",
            status: false,
          },
          {
            name: "naam3",
            email: "naam3@kyano.app",
            status: false,
          },
          {
            name: "naam4",
            email: "naam4@kyano.app",
            status: false,
          },
        ],

        profiles: [
          {
            id: 1,
            status: true,
            avatar: "https://cdn.vuetifyjs.com/images/lists/1.jpg",
            name: "Gianni Hesseling",
            functiontitle: "Developer",
            companyname: "Kyano",
          },
          {
            id: 2,
            status: false,
            avatar: "https://cdn.vuetifyjs.com/images/lists/1.jpg",
            name: "Kees Hesseling",
            functiontitle: "Developer",
            companyname: "Snelwebcenter",
          },
          {
            id: 3,
            status: false,
            avatar: "https://cdn.vuetifyjs.com/images/lists/1.jpg",
            name: "Gianni Hesseling",
            functiontitle: "Developer",
            companyname: "Snelwebcenter",
          },
        ],
        profileitems: [
          "Gianni Hesseling 11 - bedrijfsnaam",
          "Gianni Hesseling 12 - bedrijfsnaam",
          "Gianni Hesseling 13 - bedrijfsnaam",
        ],
      },

      profileitems: [
        "Gianni Hesseling - bedrijfsnaam",
        "Gianni Hesseling 2 - bedrijfsnaam",
        "Gianni Hesseling 3 - bedrijfsnaam",
      ],
    };
  },
};
</script>
<style>
.activeprofile {
  background: #34c75915;
  border: 1px solid #34c759;
  border-radius: 8px;
}

.profile-name {
  font-size: 35px;
  font-weight: bold;
}
.kyano-card-profile-banner {
  border-radius: 8px;
  overflow: hidden;
}
.kyano-card-profile-image {
  position: relative;
  margin-top: -100px;
  border-radius: 100px;
  margin-bottom: 20px;
}
/* v-card responsive full width */

.kyano-responsive-card-width {
  border-radius: 8px;
  border: 1px solid #e5e5ea;
  margin-bottom: 20px;
  padding: 20px;
}

@media (max-width: 575.98px) {
  .kyano-responsive-col-width {
    padding: 0px !important;
    background: #f5f5f9;
  }
  .kyano-responsive-card-width {
    border: none;
    border-radius: 0px !important;
  }
}
</style>
